import React, { Component } from "react";
import { Redirect } from "react-router-dom";

import Loading from "./Loading";
import common from "../common";
import currentNetwork from "../currentNetwork";
import constants from "../constants";

class RouteToHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: null,
      isLoading: true,
    };
  }

  componentDidMount() {
    console.log("in route to home");
    let savedHome = window.localStorage.getItem(common.HOME_NETWORK_KEY);

    if (!savedHome || savedHome === null) {
      savedHome = constants.defaultNetworkName;
    }
    this.setState({ redirect: "/" + savedHome, isLoading: false });

    currentNetwork.setNetwork(savedHome);
}

  render() {
    if (this.state.isLoading) {
      return <Loading />;
    }

    return <Redirect to={this.state.redirect} />;
  }
}

export default RouteToHome;
